
export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const BASE_URL_LOCAL = process.env.REACT_APP_BASE_URL_LOCAL;
